// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-grid-tile {
  background-color: #f5f5f5;
  border-radius: 0.5714285714rem;
  background-size: cover;
  background-repeat: no-repeat;
}
mat-grid-tile.support-card {
  background-color: #ffcd00;
  transition: background 0.5s;
}
mat-grid-tile .card-name {
  font-weight: bold;
  text-align: center;
  margin-top: 0.5071428571rem;
  padding: 0 6px;
}
mat-grid-tile .custom-image {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  height: 3.5714285714rem;
  background: #fff;
  opacity: 0.7;
  font-weight: bold;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.container {
  height: calc(100svh - 69px);
  margin-bottom: 15%;
}

textarea {
  border-radius: 1.7142857143rem;
  border-width: 2px;
  color: #6b645e !important;
  border-right: none;
  border-color: #edbf00 !important;
}

.btn {
  border-radius: 3.4285714286rem;
  font-size: 0.6428571429rem;
  font-weight: bold;
}
.btn:disabled {
  opacity: 0.5;
}

.input-group-text {
  background-color: #ffffff;
  border-left: none;
  border-width: 2px;
}

mat-grid-list {
  opacity: 1;
  transform: translate(0);
  transition: opacity linear 0.3s;
}

.info-container {
  transition: top 0.3s;
  top: 100%;
}

@media screen and (max-height: 450px) {
  mat-grid-list {
    opacity: 0;
    transform: translate(9999px);
  }
  .info-container {
    position: absolute;
    top: 0;
    right: 16px;
    left: 16px;
  }
}
.extra-info-input-group {
  border-radius: 24px;
  border: 2px solid #edbf00;
  background: transparent !important;
}
.extra-info-input-group textarea {
  border-color: transparent !important;
}
.extra-info-input-group button {
  margin: 4px !important;
  border-radius: 24px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/item-selector/item-selector.component.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,yBCcc;EA4Bd,8BAAA;EDxCA,sBAAA;EACA,4BAAA;AADF;AAGE;EAEE,yBCVM;EDWN,2BAAA;AAFJ;AAaE;EACE,iBAAA;EACA,kBAAA;ECqBF,2BAAA;EDnBE,cAAA;AAXJ;AAcE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;ECWF,uBAAA;EDTE,gBAAA;EACA,YCNoB;EDOpB,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAZJ;;AAgBA;EACE,2BAAA;EACA,kBCnBmB;ADMrB;;AAgBA;ECNE,8BAAA;EDQA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;AAbF;;AAoBA;EClBE,8BAAA;EAAA,0BAAA;EDqBA,iBAAA;AAjBF;AAsBE;EACE,YAAA;AApBJ;;AAwBA;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;AArBF;;AA4BA;EACE,UAAA;EACA,uBAAA;EACA,+BAAA;AAzBF;;AA4BA;EACE,oBAAA;EACA,SAAA;AAzBF;;AA4BA;EACE;IACE,UAAA;IACA,4BAAA;EAzBF;EA4BA;IACE,kBAAA;IACA,MAAA;IACA,WAAA;IACA,UAAA;EA1BF;AACF;AA6BA;EACE,mBAAA;EACA,yBAAA;EACA,kCAAA;AA3BF;AA6BE;EACE,oCAAA;AA3BJ;AA8BE;EACE,sBAAA;EACA,8BAAA;AA5BJ","sourcesContent":["@import 'variables';\n\nmat-grid-tile {\n  background-color: $card-bg-color;\n  @include pixelToRem(border-radius, $product-border-radius);\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  &.support-card {\n    //background-color: $support-card-inactive-color;\n    background-color: $primary;\n    transition: background 0.5s;\n\n    .card-name {\n      //color: $support-card-text-color;\n    }\n\n    //&.active {\n    //  background-color: $support-card-bg-color;\n    //}\n  }\n\n  .card-name {\n    font-weight: bold;\n    text-align: center;\n    @include pixelToRem(margin-top, 7.1px);\n    padding: 0 6px;\n  }\n\n  .custom-image {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    @include pixelToRem(height, 50px);\n    background: #fff;\n    opacity: $image-text-bg-opacity;\n    font-weight: bold;\n    display: flex;\n    display: -webkit-flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.container {\n  height: calc(100svh - 69px);\n  margin-bottom: $body-bottom-margin;\n}\n\ntextarea {\n  @include pixelToRem(border-radius, 24px);\n  border-width: 2px;\n  color: $text-color !important;\n  border-right: none;\n  border-color: $input-border-color !important;\n\n  //&.support-text {\n  //  border-color: $textarea-border-color !important;\n  //}\n}\n\n.btn {\n  @include pixelToRem(border-radius, $button-border-radius);\n  @include pixelToRem(font-size, 9px);\n  font-weight: bold;\n  //@include pixelToRem(padding-top, 14px);\n  //@include pixelToRem(padding-bottom, 14px);\n  //@include pixelToRem(width, 123px);\n\n  &:disabled {\n    opacity: 0.5;\n  }\n}\n\n.input-group-text {\n  background-color: #ffffff;\n  border-left: none;\n  border-width: 2px;\n\n  //&.support-text {\n  //  border-color: $textarea-border-color !important;\n  //}\n}\n\nmat-grid-list {\n  opacity: 1;\n  transform: translate(0);\n  transition: opacity linear 0.3s;\n}\n\n.info-container {\n  transition: top 0.3s;\n  top: 100%;\n}\n\n@media screen and (max-height: 450px) {\n  mat-grid-list {\n    opacity: 0;\n    transform: translate(9999px);\n  }\n\n  .info-container {\n    position: absolute;\n    top: 0;\n    right: 16px;\n    left: 16px;\n  }\n}\n\n.extra-info-input-group {\n  border-radius: 24px;\n  border: 2px solid $input-border-color;\n  background: transparent !important;\n\n  textarea {\n    border-color: transparent !important;\n  }\n\n  button {\n    margin: 4px !important;\n    border-radius: 24px !important;\n  }\n}\n","$primary: #ffcd00;\n$secondary: #00a3ae;\n$dark: #707070;\n$base-font-size: 14px;\n\n$header-top-height: 48px;\n$header-bottom-height: 21px;\n$header-border-radius: 24px;\n$header-total-height: $header-top-height + $header-bottom-height;\n$tray-radius: 16px;\n\n$input-border-radius: 24px;\n$input-side-padding: 25px;\n$header-top-color: #ffffff;\n$header-bottom-color: #ededed;\n$text-color: #6b645e;\n$login-bg-color: #a5a498;\n$card-bg-color: #f5f5f5;\n$info-text-color: #a5a498;\n$support-card-bg-color: #7ed0d6;\n$support-card-inactive-color: #bcd8df;\n$support-card-text-color: #f5f5f5;\n$category-border-radius: 16px;\n$product-border-radius: 8px;\n$textarea-border-color: #bcd8df;\n$button-border-radius: 48px;\n$support-button-size: 84px;\n$support-button-margin: 24px;\n$gradient-height: 10%;\n$body-bottom-margin: 15%;\n$input-border-color: #edbf00;\n$image-text-bg-opacity: 0.7;\n$primary-btn-border: rgba(255, 205, 0, 1);\n$fade-bg-color: #ffffffb3;\n\n@mixin set-flex($number) {\n  flex: $number;\n}\n\n@function calculateRem($size) {\n  $remSize: calc($size / $base-font-size);\n  @return #{$remSize}rem;\n}\n\n@mixin pixelToRem($attribute, $size) {\n  #{$attribute}: calculateRem($size);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
